import { Flex, Table, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;

export const sectionCardProps = {
  size: 'small',
  className: 'org-settings-card',
  styles: { body: { padding: '8px 20px 16px' } },
};

export const sectionStackGap = 20;
export const formItemStyle = { marginBottom: 20 };
export const settingsContentMaxWidth = 880;

export function SectionTitle({ title, tag }) {
  return (
    <Flex align="center" gap={8} wrap="wrap">
      <span>{title}</span>
      {tag}
    </Flex>
  );
}

export function InfoTable({ rows }) {
  return (
    <Table
      size="small"
      pagination={false}
      showHeader={false}
      rowKey="label"
      dataSource={rows}
      columns={[
        {
          dataIndex: 'label',
          width: 200,
          render: (v) => <Text style={{ color: 'rgba(0, 0, 0, 0.75)' }}>{v}</Text>,
        },
        {
          dataIndex: 'value',
          render: (v) => v,
        },
      ]}
    />
  );
}
